import { useEffect, useState } from "react";
import { api } from "./api";

let cached = null;

export const usePublicConfig = () => {
  const [config, setConfig] = useState(cached);
  useEffect(() => {
    if (cached) return;
    api.get("/public/config").then(({ data }) => {
      cached = data;
      setConfig(data);
    }).catch(() => setConfig({ branding: {}, wallet_enabled: false }));
  }, []);
  return config;
};

export const updateCachedBranding = (branding) => {
  if (cached) cached = { ...cached, branding };
};

export const updateCachedProfileDesign = (profile_design) => {
  if (cached) cached = { ...cached, profile_design };
};

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
